import auth from '@/modules/auth'
import menu from '@/modules/menu'
import ui from '@/modules/ui'
import coordinator from '@/modules/coordinator'
import utils from '@/modules/utils'
import employees from '@/modules/employees'
import ci from '@/modules/ci'
export default {
  auth,
  menu,
  ui,
  coordinator,
  utils,
  employees,
  ci,
}
